import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Zap, Clock, CreditCard } from "lucide-react";
// import { Button } from "@/components/ui/button";
// import { Card, CardContent } from "@/components/ui/card";
import { Button } from "../RentCar/public/component/Button";
import { Card, CardContent } from "../RentCar/public/component/Card";

export default function HelloLPay() {
    return (
        <div className="min-h-screen bg-gradient-to-b from-indigo-50 via-white to-gray-50 text-gray-800">
            {/* Navbar */}
            <header className="flex justify-between items-center px-10 py-6 shadow-sm bg-white/70 backdrop-blur-md">
                <h1 className="text-2xl font-bold text-indigo-700">L`Pay</h1>
                <nav className="space-x-6 text-sm font-medium">
                    <a href="#features" className="hover:text-indigo-600">Features</a>
                    <a href="#integration" className="hover:text-indigo-600">Integration</a>
                    <a href="#contact" className="hover:text-indigo-600">Contact</a>
                </nav>
                <Button className="bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl px-5 py-2">
                    Dashboard
                </Button>
            </header>

            {/* Hero Section */}
            <section className="flex flex-col items-center justify-center text-center py-24 px-6">
                <motion.h2
                    className="text-5xl font-extrabold text-gray-900 leading-tight"
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    Simplify Your <span className="text-indigo-600">Online Payments</span>
                </motion.h2>
                <p className="mt-4 text-gray-600 max-w-xl">
                    Fast, secure, and scalable for your business.
                    Start accepting transactions in minutes.
                </p>
                <div className="mt-8 flex gap-4">
                    <Button  className="bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl px-6 py-3">
                        Get Started
                    </Button>
                </div>
            </section>

            {/* Features */}
            <section id="features" className="py-20 bg-white">
                <div className="max-w-6xl mx-auto text-center">
                    <h3 className="text-3xl font-bold mb-12 text-gray-900">
                        Why Choose L`Pay?
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-10">
                        {[
                            { icon: <ShieldCheck className="w-10 h-10 text-indigo-600" />, title: "Secure", desc: "End-to-end encryption with fraud protection." },
                            { icon: <Zap className="w-10 h-10 text-indigo-600" />, title: "Fast", desc: "Process payments instantly with 99.9% uptime." },
                            { icon: <Clock className="w-10 h-10 text-indigo-600" />, title: "Reliable", desc: "Trusted by 10,000+ businesses globally." },
                        ].map((f, i) => (
                            <Card key={i} className="rounded-2xl shadow-md hover:shadow-lg transition">
                                <CardContent className="flex flex-col items-center p-8 space-y-3">
                                    {f.icon}
                                    <h4 className="text-lg font-semibold">{f.title}</h4>
                                    <p className="text-gray-500">{f.desc}</p>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                </div>
            </section>

            {/* Integration Section */}
            <section id="integration" className="py-24 bg-gradient-to-b from-indigo-50 to-white">
                <div className="max-w-6xl mx-auto text-center">
                    <h3 className="text-3xl font-bold mb-6">Developer-Friendly Integration</h3>
                    <p className="text-gray-600 max-w-2xl mx-auto mb-12">
                        Connect L`Pay with your system using REST APIs or ready-to-use SDKs.
                    </p>
                    {/* <div className="flex justify-center">
                        <Card className="p-6 rounded-2xl shadow-md max-w-md">
                            <CardContent>
                                <pre className="bg-gray-900 text-green-400 text-left p-4 rounded-xl text-sm overflow-auto">
                                    {`curl -X POST https://api.paylink.id/v1/payments
-H "Authorization: Bearer <token>"
-d '{ "amount": 50000, "method": "VA_BCA" }'`}
                                </pre>
                            </CardContent>
                        </Card>
                    </div> */}
                </div>
            </section>

            {/* Footer */}
            <footer id="contact" className="py-10 border-t text-center text-gray-500 text-sm">
                <p>© 2025 L`Pay. All rights reserved.</p>
                <div className="mt-3 space-x-4">
                    <a href="#" className="hover:text-indigo-600">Privacy</a>
                    <a href="#" className="hover:text-indigo-600">Terms</a>
                    <a href="#" className="hover:text-indigo-600">Support</a>
                </div>
            </footer>
        </div>
    );
}
